import React from 'react';
import { GiBarrier} from 'react-icons/gi'
import StartNow from '../../../Common-components/start-now/StartNow';

const Pratibimb = () => {
    return (  
        // <>
        //     <GiBarrier  size={250} style={{marginLeft:"42%"}}/>
        //     <div style={{textAlign:"center"}}>This Page is under Construction.....</div>
        // </>
        <>


    <div style={{textAlign:'center'}}>
       <StartNow/>
     </div>
        
        
        </>
    );
}
 
export default Pratibimb;